// import * as jsx from "@babel/plugin-transform-react-jsx";
// import * as ts from "@babel/plugin-transform-typescript";

const getBabelPlugins = async () => {
	if (typeof window === "undefined") {
		const jsxModule = "@babel/plugin-transform-react-jsx";
		const tsModule = "@babel/plugin-transform-typescript";
		const [jsx, ts] = await Promise.all([
			import(/* webpackIgnore: true */ jsxModule).then((m) => m.default),
			import(/* webpackIgnore: true */ tsModule).then((m) => m.default),
		]);
		return [jsx, ts];
	} else {
		const [jsx, ts] = await Promise.all([
			import("@babel/plugin-transform-react-jsx").then((m) => m.default),
			import("@babel/plugin-transform-typescript").then((m) => m.default),
		]);
		return [jsx, ts];
	}
};

export const standardParserPlugins = async () => {
	const [jsx, ts] = await getBabelPlugins();
	if (!jsx || !ts) {
		throw new Error("Babel plugins are not available in this environment");
	}
	return [jsx, [ts, { isTSX: true }]];
};
